import React, { FC } from "react";

import { Link, Stack, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";

import { setupType } from "./SetupDialog";

interface ChooseSetupTypeProps {
  chooseSetupType: (option: setupType) => void;
}

export const ChooseSetupType: FC<ChooseSetupTypeProps> = ({
  chooseSetupType,
}) => {
  return (
    <Stack direction="column" spacing={2}>
      <Typography sx={{ pt: 2, maxWidth: 800 }}>
        Pomerium can authorize requests to Kubernetes in different ways. Choose
        an authorization method to continue.
      </Typography>
      <Stack direction="row" spacing={2}>
        <Card variant="elevation" sx={{ p: 2, maxWidth: 400 }}>
          <Stack direction="column" spacing={2} justifyContent="space-between">
            <Typography variant="h4">JWT Authentication</Typography>
            <Typography>
              Using{" "}
              <Link href="https://kubernetes.io/docs/reference/access-authn-authz/authentication/#using-authentication-configuration">
                Structured Authentication
              </Link>
              , Kubernetes can use the Pomerium JWT to natively authenticate
              requests.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => chooseSetupType("config")}
            >
              Choose Config
            </Button>
          </Stack>
        </Card>
        <Card variant="elevation" sx={{ p: 2, maxWidth: 400 }}>
          <Stack direction="column" spacing={2} justifyContent="space-between">
            <Typography variant="h4">Impersonation Headers</Typography>
            <Typography>
              Using{" "}
              <Link href="https://kubernetes.io/docs/reference/access-authn-authz/authentication/#using-authentication-configuration">
                Impersonation
              </Link>
              , Kubernetes can use the Pomerium JWT to natively authenticate
              requests.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => chooseSetupType("token")}
            >
              Choose Token
            </Button>
          </Stack>
        </Card>
      </Stack>
    </Stack>
  );
};
